const fetch = require('isomorphic-fetch');
const getConfig = require('next/config').default;

const CasLogLevel = {
  NotSet: 0,
  Debug: 1,
  Information: 2,
  Error: 3,
};

function safelyToString(item) {
  const keyBlackList = ['operation', 'forward']; // Apollo query internals not required
  let str = '';
  if (typeof item === 'string') {
    str = item;
  }

  if (typeof item === 'boolean' || typeof item === 'number') {
    str = item.toString();
  }

  if (typeof item === 'object') {
    const props = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const key in item) {
      if (key && !keyBlackList.includes(key)) {
        const value = item[key];
        props.push(`${key}: ${safelyToString(value)}`);
      }
    }
    if (props.length === 0) {
      if (item.message) {
        props.push(`message: ${safelyToString(item.message)}`);
      }

      if (item.stack) {
        props.push(`stack: ${safelyToString(item.stack)}`);
      }

      props.push(`toString: ${safelyToString(item.toString())}`);
    }

    str += `{ ${props.join(', ')} }`;
  }

  return str;
}

function logToCasServerSide(req, casLogLevel, controller = '', action = '', error = null) {
  const { publicRuntimeConfig } = getConfig();
  const { ENVIRONMENT } = publicRuntimeConfig;
  //  check if we have verbose logging enabled in octopus, if not, only log errors
  if (!ENVIRONMENT.VerboseFELogging && casLogLevel !== CasLogLevel.Error) return;
  let body = '';
  try {
    body = JSON.stringify(error, Object.getOwnPropertyNames(error));
  } catch (e) {
    body = 'Problem parsing error';
  }

  const url = ENVIRONMENT && ENVIRONMENT.IBEUrl ? `${ENVIRONMENT.IBEUrl}/api/Logger/PostLogItem` : '';
  // Extracting the cookies from the request
  // otherwise CAS ID will be different to original session
  const originalRequestCookies = req.headers.cookie;
  const data = JSON.stringify({
    auditType: casLogLevel,
    controller: `UI - ${controller}`,
    action,
    body,
  });

  fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Cache-Control': 'no-store',
      'Content-Type': 'application/json',
      Cookie: originalRequestCookies,
    },
    body: data,
  }).then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error, Status: ${response.status}`);
    }
    // Check if the content is there to be parsed
    const contentType = response.headers.get('Content-Type');
    if (contentType && contentType.includes('application/json')) {
      return response.json();
    }
    return null; // otherwise, no content returned to parse.
  })
    .catch((e) => {
      console.error(e.message);
    });
}

module.exports.default = logToCasServerSide;
module.exports.CasLogLevel = CasLogLevel;
module.exports.safelyToString = safelyToString;
